/**
 * 생산 단위 옵션 (product_master.unitSmallCode 표시용)
 */
export const PRODUCT_UNITS = [
    { value: "EA", label: "EA (개)" },
    { value: "KG", label: "KG (킬로그램)" },
    { value: "TON", label: "TON (톤)" },
    { value: "L", label: "L (리터)" },
    { value: "M", label: "M (미터)" },
    { value: "M2", label: "M² (제곱미터)" },
    { value: "M3", label: "M³ (세제곱미터)" },
    { value: "BOX", label: "BOX (박스)" },
    { value: "SET", label: "SET (세트)" },
    { value: "ROLL", label: "ROLL (롤)" },
];

export default PRODUCT_UNITS;
